import axios from "axios";
import { trackException } from "./telemetry/appInsights";

const baseURL = process.env.REACT_APP_CTLG_URL;
const access_token = localStorage.getItem("access_token") || "";

const unAuthenticated = {
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
};

const authenticated = {
  baseURL,
  json: true,
  headers: {
    "Content-Type": "application/json",
    ...(access_token.trim() ? { Authorization: `Bearer ${access_token}` } : {}),
  },
};

const axiosInstance = axios.create(
  access_token.trim() ? authenticated : unAuthenticated,
);

axiosInstance.interceptors.request.use((request) => {
  request.headers = request.headers || {};
  const token = localStorage.getItem("access_token");

  if (token && token.trim() !== "") {
    request.headers.Authorization = `Bearer ${token}`;

    try {
      const [, payloadB64] = token.split(".");
      if (payloadB64) {
        const payload = JSON.parse(atob(payloadB64));
        const expMs = (payload?.exp ?? 0) * 1000;
        if (Date.now() >= expMs) {
          window.dispatchEvent(new Event("sessionExpired"));
        }
      }
    } catch (error) {
      console.error(`Auth interceptor error: `, error);
    }
  } else {
    if ("Authorization" in request.headers) {
      delete request.headers.Authorization;
      window.dispatchEvent(new Event("sessionExpired"));
    }
  }

  return request;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response || error.request) {
      trackException(error, {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        errorData: error.response?.data,
      });
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
